import React from "react";

const OurStorySection = () => (
  <section
    id="story"
    className="section-padding our-story-section"
    data-testid="our-story-section"
  >
    <div className="container">
      <div className="our-story-grid">
        <div className="our-story-block">
          <span className="our-story-eyebrow">Our Story</span>
          <h1 className="our-story-title">
            From the heart of Waiʻanae,<br />
            a quiet kind of luxury.
          </h1>
          <div className="our-story-body">
            <p>
              Roots from the heart of Waiʻanae, Oʻahu, ʻAlohi is inspired by my three
              daughters — my brightest light. With over a decade of experience in
              aesthetics, I&rsquo;ve created a lifestyle line that nurtures the mind,
              body, and spirit, encouraging balance, rest, and radiant living.
            </p>
            <p>
              Every product is a reflection of my daughters&rsquo; roots in these islands
              and the lessons they teach me daily about{" "}
              <em>Ola</em> — the essence of life. Crafted with care and intention,
              our creations are a <em>Makana</em> (gift) from our ʻohana to yours,
              meant to bring beauty, connection, and ʻAlohi into your life and into
              the world.
            </p>
          </div>
          <span className="our-story-signoff">— Veronica &amp; the ʻAlohi ʻohana</span>
        </div>
        <div className="our-story-portrait" data-testid="our-story-portrait">
          <img
            src="/images/our-story-family.jpg"
            alt="Veronica and her daughters — the ʻAlohi ʻohana, Waiʻanae, Oʻahu"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  </section>
);

export default OurStorySection;
